import { GetCartResource, GetCartResourceCartItems } from "../generated-api";

export const formattedCart = (cart: GetCartResource): GetCartResourceCartItems | null => {
  return cart.cart_items.length > 0 ? cart.cart_items[0] : null;
};
